var mainProduct = function () {

    // Selectors object
    var selectors = {
        productSingleGallery: document.querySelector('[data-product-single-gallery]'),
        productSingleThumbnailGallery: document.querySelector('[data-product-single-thumbnails]'),
        productSingleThumbnails: document.querySelectorAll('[data-product-single-thumbnail]'),
        addToCart: '[data-add-to-cart]',
    };
    
    // Local function name - not available outside this object
    var listeners = function (){
        
        var productSingleGallerySwiper = new Swiper(selectors.productSingleGallery, {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 1.2,
            watchSlidesProgress: true,
            preloadImages: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                989: {
                    slidesPerView: 1,
                }
            }
        });
        productSingleGallerySwiper.on('slideChange', function () {
            let activeIndex = productSingleGallerySwiper.activeIndex
            selectors.productSingleThumbnails.forEach(trigger => {
                if(trigger.dataset.slideIndex == activeIndex){
                    trigger.classList.add('is--active');
                } else{
                    trigger.classList.remove('is--active');
                }
            })
        });

        selectors.productSingleThumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", (e) =>{
                let clickedThumbnail = e.target.closest('[data-product-single-thumbnail]');
                let slideIndex = clickedThumbnail.dataset.slideIndex;
                productSingleGallerySwiper.slideTo(slideIndex, 500, false);

                // selectors.productSingleThumbnails.forEach(trigger => {
                //     if(clickedThumbnail !== trigger){
                //         trigger.classList.remove('is--active');
                //     }
                // })
                // clickedThumbnail.classList.add('is--active');
            });
        });
    };

    // listeners();

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const desktopRef = ".product-single__description.product-single__description-desktop--short.small--hide";
    const mobileRef = ".product-single__description.product-single__description-mobile--short.medium-up--hide";

    const container = document.querySelector(`${isMobile ? mobileRef : desktopRef}`);
    const readMoreToggleLink = document.querySelector('.pdp__read-more');
    if(readMoreToggleLink) {
        readMoreToggleLink.addEventListener('click', e => {
            e.preventDefault();
            const isExpanded = container.classList.toggle('expanded');
            container.classList.toggle('collapsed', !isExpanded);
            readMoreToggleLink.textContent = isExpanded ? 'Read less' : 'Read more';
        });
    }

}();